import React from 'react'
import {Button, Fade, FormControl, Modal, TextField} from "@material-ui/core";

export const SmsModal = ({visible, smsCode, handleChangeCode, onSubmitHandler}) => (
    <Modal
        open={visible}
        onClose={console.log}
        closeAfterTransition
        disableBackdropClick={true}
        className="sms-modal-window"
        BackdropProps={{
            timeout: 500,
        }}
    >
        <Fade className="sms-modal-body" in={visible}>
            <div>
                <div className="logo">
                    <img alt="logo-booking"
                         src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/logo_booking_small.png'}/>
                </div>
                <div className="title-block">
                    Введите код из смс
                </div>
                <FormControl
                    className="hide-border input-grey flex-full-width"
                >
                    <TextField
                        placeholder="Код"
                        type="number"
                        onChange={handleChangeCode}
                        className="sms-code-input"
                        value={smsCode}
                        variant="outlined"
                    />
                </FormControl>
                <Button variant="contained"
                        onClick={onSubmitHandler}
                        disabled={smsCode.length !== 4}
                        color="secondary"
                        className={'confirm-button' + (smsCode.length !== 4 ? '' : ' enabled')}
                >
                    Продолжить
                </Button>
            </div>
        </Fade>
    </Modal>
);



